import React from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'
import {
  IconButton,
  Input,
  MenuItem,
  Select,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { mdiDelete, mdiPlus } from '@mdi/js'

import VariantInput, { VariantTypeMapping } from '../controls/input/VariantInput'

class ParamListView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    params: PropTypes.object,
    // unitId: PropTypes.number,
    onChange: PropTypes.func.isRequired,
  }

  static defaultProps = {
    params: {},
    // unitId: undefined,
  }

  static styles = () => ({
    root: {
      width: 'auto',
    },
  })

  state = {
    addName: '',
    addType: '',
  }

  onNameChange = (e) => {
    this.setState({ addName: e.target.value })
  }

  onTypeChange = (e) => {
    this.setState({ addType: e.target.value })
  }

  onAdd = () => {
    const { addName, addType } = this.state
    const params = {
      ...this.props.params,
      [addName]: {
        type: addType,
      },
    }
    this.props.onChange(params)
    this.setState({ addName: '' })
  }

  onRemove = (name) => {
    const { [name]: _, ...params } = this.props.params

    this.props.onChange(params)
  }

  onParamChange = (name, p) => {
    const params = {
      ...this.props.params,
      [name]: p,
    }
    this.props.onChange(params)
  }

  renderRow = ([name, param]) => (
    <TableRow key={name}>
      <TableCell size="small">
        {name}
      </TableCell>
      <TableCell size="small">
        {param.type}
      </TableCell>
      <TableCell size="small">
        <VariantInput
          value={param}
          onChange={(p) => this.onParamChange(name, p)}
        />
      </TableCell>
      <TableCell padding="none">
        <IconButton aria-label="Delete" onClick={() => this.onRemove(name)}>
          <SvgIcon>
            <path d={mdiDelete} />
          </SvgIcon>
        </IconButton>
      </TableCell>
    </TableRow>
  )

  render() {
    const { params, classes } = this.props

    const { addName, addType } = this.state

    const paramList = Object.entries(params).sort((a, b) => a[0].localeCompare(b[0]))

    return (
      <Table className={classes.root}>
        <TableHead>
          <TableRow>
            <TableCell size="small">
              Name
            </TableCell>
            <TableCell size="small">
              Type
            </TableCell>
            <TableCell size="small">
              Value
            </TableCell>
            <TableCell padding="none" />
          </TableRow>
        </TableHead>
        <TableBody>
          {paramList.map(this.renderRow)}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell size="small">
              <Input
                value={addName}
                onChange={this.onNameChange}
              />
            </TableCell>
            <TableCell size="small">
              <Select
                value={addType}
                onChange={this.onTypeChange}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {Object.entries(VariantTypeMapping).map(([type, { name }]) => (
                  <MenuItem value={type} key={`${type}-${name}`}>{name}</MenuItem>
                ))}
              </Select>
            </TableCell>
            <TableCell size="small" />
            <TableCell padding="none">
              <IconButton aria-label="Add" onClick={this.onAdd}>
                <SvgIcon>
                  <path d={mdiPlus} />
                </SvgIcon>
              </IconButton>
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    )
  }
}

export default withStyles(ParamListView.styles)(ParamListView)
